import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=946b74e2&"
import script from "./main.js?vue&type=script&lang=js&"
export * from "./main.js?vue&type=script&lang=js&"
import style0 from "./main.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports